<template>
  <div class="animated fadeIn">
    <b-row>
      <b-col lg="9">
        <!-- <b-form-input
          size="sm"
          class="mr-sm-2"
          type="text"
          placeholder="Search"
          @keyup="filterList"
          v-model="searchString"
        />-->
        <b-form-group>
          <b-input-group>
            <b-form-input
              type="text"
              placeholder="Search"
              @keyup="filterList"
              v-model="searchString"
            />

            <b-input-group-append>
              <b-input-group-text>
                <i class="fa fa-times appendIcon clickIcon" @click="resetSearch"></i>
              </b-input-group-text>
            </b-input-group-append>
          </b-input-group>
        </b-form-group>
      </b-col>

      <b-col lg="3">
        <div class="form-group form-actions float-right pb-2">
          <b-button
            class="mr-2 btn"
            variant="success"
            type="submit"
            size="md"
            @click="newRestaurant"
          >
            <i class="fa fa-address-card-o"></i>
            New Restaurant
          </b-button>
        </div>
        <div>
          <StyledDialog
            @filterList="filterList"
            :CurrentObject="mySelected"
            EntityType="Restaurant"
          >
            <div slot="header">
              <h2>{{mySelected.Name}}</h2>
            </div>
            <div slot="details">
              <div>{{mySelected.Address1}} {{mySelected.Address2}}</div>
            </div>
            <span slot="entityType">Restaurant</span>
          </StyledDialog>
        </div>
      </b-col>
    </b-row>

    <b-row></b-row>
    <b-row>
      <b-col sm="12">
        <b-table
          @row-clicked="myRowClickHandler"
          :items="filteredRestaurants"
          :fields="fields"
          hover
          small
          fixed
          caption
          selectable
          select-mode="single"
          responsive="sm"
          selectedVariant="success"
          :current-page="currentPage"
          :per-page="perPage"
        >
          <template slot="Functions" slot-scope="data">
            <i
              v-b-tooltip
              title="Delete"
              class="fa fa-trash"
              v-b-modal.modal-2
              @click="SetItemToDelete(data.item)"
            ></i>
          </template>
        </b-table>

        <nav v-show="isNavVisible">
          <b-pagination
            :per-page="perPage"
            :total-rows="totalRowsFiltered"
            v-model="currentPage"
            prev-text="Prev"
            next-text="Next"
            hide-goto-end-buttons
          />
        </nav>
      </b-col>
    </b-row>
  </div>
</template>

<script>
import { mapState, mapActions } from "vuex";
import cTable from "@/views/base/Table.vue";
//import DeleteDialog from "@/components/dialogs/DeleteDialog.vue";
import StyledDialog from "@/components/dialogs/StyledModal.vue";
import moment from "moment";

export default {
  name: "RestaurantList",
  data: () => {
    return {
      fields: [
        {
          key: "Functions",
          label: "",
          sortable: false,
          thStyle: "width: 5%;"
        },
        { key: "Name", label: "Restaurant", sortable: true },
        { key: "Address1", label: "Address", sortable: true },
        { key: "City", label: "City", sortable: true },
        { key: "State", label: "State", sortable: true },
        { key: "Zip", label: "Postal Code", sortable: true }
      ],
      mySelected: { Restaurant: {} },
      currentPage: 1,
      perPage: 25,
      filteredRestaurants: [],
      searchString: ""
    };
  },
  components: {
    cTable,
    //DeleteDialog,
    StyledDialog
  },
  created() {
    this.$store.dispatch("seminar/fetchRestaurants").then(this.filterList());
    //this.filteredCampaigns = this.$store.state.campaign.campaigns;
    //this.filterList();
  },
  computed: {
    totalRows: function() {
      return this.$store.state.seminar.restaurants.length;
      //return 4;
    },
    totalObjects: function() {
      return this.$store.state.seminar.restaurants;
      //return 4;
    },
    totalRowsFiltered: function() {
      return this.filteredRestaurants.length;
    },
    isNavVisible: function() {
      return this.totalRowsFiltered > this.perPage;
    },
    ...mapState(["seminar", "notification"]),
    ...mapActions("notification", ["add", "remove"])
  },
  updated() {
    this.incrementCount;
  },
  watch: {
    totalObjects(newValue, oldValue) {
      this.filterList();
    }
  },
  methods: {
    filterList: function() {
      this.filteredRestaurants = this.$store.state.seminar.restaurants.filter(
        restaurant =>
          restaurant.Name.toLowerCase().indexOf(
            this.searchString.toLowerCase()
          ) > -1 ||
          restaurant.Address1.toLowerCase().indexOf(
            this.searchString.toLowerCase()
          ) > -1 ||
          restaurant.City.toLowerCase().indexOf(
            this.searchString.toLowerCase()
          ) > -1 ||
          restaurant.State.toLowerCase().indexOf(
            this.searchString.toLowerCase()
          ) > -1 ||
          restaurant.Zip.toLowerCase().indexOf(
            this.searchString.toLowerCase()
          ) > -1
      );
    },
    resetSearch: function() {
      this.searchString = "";
      this.filterList();
    },
    incrementCount() {
      this.$store.commit("INCREMENT_COUNT");
    },
    SetItemToDelete(object) {
      this.mySelected = object;
    },
    myRowClickHandler(record, index) {
      this.$store
        .dispatch("seminar/loadRestaurantEdit", record.RestaurantID)
        .then(() => {
          this.$router.push({ name: "Restaurant" });
        });
    },
    newRestaurant() {
      this.$store
        .dispatch("seminar/newRestaurant", this.createFreshRestaurantObject())
        .then(() => {
          this.$router.push({ name: "Restaurant" });
          //,
          //params: { id: this.event.id }
        })
        .catch(() => {
          console.log("There was a problem");
          //.dispatch('notification/add', this.event)
        });
    },
    deleteUser() {
      //this.$store.dispatch("n_user/createUser", this.createFreshUserObject());
    },
    createFreshRestaurantObject() {
      return {
        RestaurantID: -1
      };
    },
    GetEarliestMailDate() {
      switch (moment().day()) {
        // If it is Monday (1),Saturday(6), or Sunday (0), Get the previous Friday (5)
        // and ensure we are on the previous week
        case 0:
          return moment().add(5, "days");
        case 1:
          return moment().add(4, "days");
        case 2:
          return moment().add(10, "days");
        case 3:
          return moment().add(9, "days");
        case 4:
          return moment().add(8, "days");
        case 5:
          return moment().add(7, "days");
        case 6:
          return moment().add(6, "days");
        default:
          return moment().add(3, "days");
      }
    }
  }
};
</script>

<style lang="scss" scoped>
</style>